import { SPI, http, Widget, ViewWidget, DslNodeWidget, ClearCache, useRouter, MessageHub } from '@kunlun/dependencies';
import gql from 'graphql-tag';
import Comp from './MerchantUser.vue';
import { MessageHubKey } from '@/constants/messageHub';

@SPI.ClassFactory(ViewWidget.Token({ widget: 'merchantUser' }))
export default class MerchantUser extends DslNodeWidget {
  @Widget.Reactive()
  private pamirsPartner: Record<string, unknown> = { name: '' };

  @Widget.Reactive()
  private pamirsPartnerList: Record<string, unknown>[] = [];

  public initialize(props) {
    super.initialize(props);
    this.setComponent(Comp);
    return this;
  }

  protected async mounted() {
    const url = new URL(location.href);
    const partnerId = url.searchParams.get('partnerId');
    const partnerName = url.searchParams.get('partnerName');

    if (partnerId && partnerName) {
      await this.onUserChange({ id: partnerId, name: partnerName }, false);
      url.searchParams.delete('partnerId');
      url.searchParams.delete('partnerName');
      location.href = url.href;
      return;
    }

    const queryStr = gql`
      mutation {
        ariesMerchantUserPartnerMutation {
          queryCurrentUserPartners(ariesMerchantUserPartner: {}) {
            pamirsPartner {
              id
              name
            }
            pamirsPartnerList {
              id
              name
            }
          }
        }
      }
    `;
    const data = await http.mutate('ariesCoreMerchant', queryStr);
    const queryCurrentUserPartners = data.data?.ariesMerchantUserPartnerMutation?.queryCurrentUserPartners;
    this.pamirsPartnerList = (queryCurrentUserPartners?.pamirsPartnerList || []) as Record<string, unknown>[];
    this.pamirsPartner = queryCurrentUserPartners.pamirsPartner as Record<string, unknown>;
  }

  @Widget.Method()
  private async onUserChange(pamirsPartner: Record<string, unknown>, reloadAfterComplete = true) {
    ClearCache.clear();
    this.pamirsPartner = pamirsPartner;
    const queryStr = gql`mutation {
              ariesMerchantUserPartnerMutation{
                changeCurrentUserPartner(
                  ariesMerchantUserPartner:{
                    pamirsPartner:{
                     id: "${pamirsPartner.id}",
                    name: "${pamirsPartner.name}"
                    }
                  }
                ){
                  pamirsPartner{
                    id
                    name
                  }
                  pamirsPartnerList{
                    id
                    name
                  }
                }
              }
            }
            `;
    const data = await http.mutate('ariesCoreMerchant', queryStr);
    if (reloadAfterComplete) {
      // 本页刷新
      location.href = '/';
    } else {
      MessageHub.info(MessageHubKey.ChangeUser);
    }
  }
}
